import React from 'react';
import Image from '../pics';
import { useLocation, Link } from 'react-router-dom';
import UIkit from 'uikit';

function Navbar() {
  const location = useLocation();
  const currentPath = location.pathname;

  // Function to close the off-canvas menu
  const closeOffcanvas = () => {
    UIkit.offcanvas('#offcanvas-nav-primary').hide();
  };

  return (
    <div>
      <div className="custom-navbar-bg uk-background-cover uk-preserve-color">
        <div data-uk-sticky="start: 170; animation: uk-animation-slide-top; sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky; cls-inactive: uk-navbar-transparent; end: ! *; offset: 80">
          <nav className="uk-navbar-container">
            <div className="uk-container">
              <div data-uk-navbar>
                <div className="uk-navbar-left">
                  <ul className="uk-navbar-nav">
                    <li>
                      <a href="/#" className='uk-text-bold'>
                        <img className='imgs' src={Image.LOGO} alt="Logo" width='300px' />
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="uk-navbar-right">
                  <ul className="uk-navbar-nav uk-visible@m">
                    <li className={currentPath === '/' ? 'uk-active' : ''}>
                      <Link to="/" className="uk-text-capitalize">Home</Link>
                    </li>
                    <li className={currentPath === '/about' ? 'uk-active' : ''}>
                      <Link to="/about" className="uk-text-capitalize">About us</Link>
                    </li>
                    <li className={currentPath === '/service' ? 'uk-active' : ''}>
                      <Link to="/service" className="uk-text-capitalize">Service</Link>
                    </li>
                    <li className={currentPath === '/career' ? 'uk-active' : ''}>
                      <Link to="/career" className="uk-text-capitalize">Career</Link>
                    </li>
                    <li className={currentPath === '/contact' ? 'uk-active' : ''}>
                      {/* <a href="https://onlinebooking.mystratos.co.in" className="uk-text-capitalize">Book a Shipment</a> */}
                      <Link to="/contact" className="uk-text-capitalize">Book a Shipment</Link>
                    </li>
                    <li className={currentPath === '/track' ? 'uk-active' : ''}>
                      <Link to="/track" className="uk-text-capitalize">Track</Link>
                    </li>
                    <li className={currentPath === '/contact' ? 'uk-active' : ''}>
                      <Link to="/contact" className="uk-text-capitalize">Contact us</Link>
                    </li>
                  </ul>
                  <div className="uk-hidden@m">
                    <button className="" data-uk-toggle="target: #offcanvas-nav-primary">
                      menu
                    </button>
                    <div id="offcanvas-nav-primary" uk-offcanvas="overlay: true">
                      <div className="uk-offcanvas-bar uk-flex uk-flex-column">
                        <button className="uk-offcanvas-close" type="button" data-uk-close></button>
                        <ul className="uk-nav uk-nav-primary uk-nav-center uk-margin-auto-vertical">
                          <li className="uk-active">
                            <img src={Image.LOGO} alt="Logo" width="300px" />
                          </li>
                          <li className={currentPath === '/' ? 'uk-active' : ''}>
                            <Link to="/" className="uk-text-capitalize" onClick={closeOffcanvas}>Home</Link>
                          </li>
                          <li className={currentPath === '/service' ? 'uk-active' : ''}>
                            <Link to="/service" className="uk-text-capitalize" onClick={closeOffcanvas}>Service</Link>
                          </li>
                          <li className={currentPath === '/about' ? 'uk-active' : ''}>
                            <Link to="/about" className="uk-text-capitalize" onClick={closeOffcanvas}>About us</Link>
                          </li>
                          <li className={currentPath === '/career' ? 'uk-active' : ''}>
                            <Link to="/career" className="uk-text-capitalize" onClick={closeOffcanvas}>Career</Link>
                          </li>
                          <li onClick={closeOffcanvas}>
                            <a href="https://onlinebooking.mystratos.co.in" className="uk-text-capitalize">Book a Shipment</a>
                          </li>
                          <li className={currentPath === '/track' ? 'uk-active' : ''}>
                            <Link to="/track" className="uk-text-capitalize" onClick={closeOffcanvas}>Track</Link>
                          </li>
                          <li className={currentPath === '/contact' ? 'uk-active' : ''}>
                            <Link to="/contact" className="uk-text-capitalize" onClick={closeOffcanvas}>Contact us</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
